import { userTipo } from "../services/auth";
import menuEmpreendedor from "./empreendedor";
import menuGestor from "./gestor";
import menuAdministrador from "./administrador";
import { MenuItem } from "./interface";

let objMenu: MenuItem[] = []
if (userTipo() === 1) {
    objMenu = [
        ...menuGestor
    ]
} else if (userTipo() === 2) {
    objMenu = [
        ...menuEmpreendedor
    ]
} else if (userTipo() === 3) {
    objMenu = [
        ...menuAdministrador
    ]
}
const menuList: MenuItem[] = objMenu;

export default menuList
